module.exports = __webpack_public_path__ + "img/802db16.png";